import {Box, Typography} from '@yandex-delivery/blocks'
import React from 'react'

import type {Badge as BadgeProps} from '../types'
import * as classes from './classes'

export const Badge: React.FC<BadgeProps> = props => {
  const {text, background_color} = props

  return (
    <Box className={classes.badge} style={{backgroundColor: background_color}}>
      <Typography color="invert" group="tight" thickness="medium" variant="caption1">
        {text}
      </Typography>
    </Box>
  )
}

Badge.displayName = 'Badge'
